<template>
    <v-container>
        <v-row>
            <v-btn icon @click="vote(localItem, 1)">
                <v-icon :color="getVoteColour(localItem)">mdi-plus</v-icon>
            </v-btn>
        </v-row>
        <v-list-item-title v-text="getUpvotes"></v-list-item-title>
    </v-container>
</template>

<script>
import firebase from '@/fb'; 
import fbAdmin from 'firebase';
import TreatmentDataService from './../../../services/treatmentDataService.js';
import moment from 'moment';
import Activity from './../../Management/ActivityTracker/activity.js';
import Toast from './../../../plugins/customToast.js';

  export default {
    data () {
      return {
        localItem: {},
        activity: new Activity()
      }
    },
    props: {
        parentItem: Object,
        commentMode: Boolean,
        commentItem: Object,
        parentType: String
        //Could change the commentMode to a string, have treatment, commentCase, commentTreatment...
    },
    watch: {
        parentItem: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                //Check if there has been a change, based on whether in comment mode or not
                if (!this.commentMode)
                {
                    if (this.localItem !== val){
                        this.localItem = val;
                    }
                }
            }
        },
        commentItem: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                //Check if there has been a change, based on whether in comment mode or not
                if (this.commentMode)
                {
                    if (this.localItem !== val){
                        this.localItem = val;
                    }
                }
            }
        }
    },
    computed: {
        getUpvotes(){
            //A computed property to get upvotes, so that it actually updates information
            if (this.commentMode){
                return this.commentItem.upvotes;
            } else {
                return this.parentItem.data.upvotes;
            }
        }
    },
    mounted(){
        //Check if there has been a change
        if (this.commentMode)
        {
            if (this.localItem !== this.commentItem){
                this.localItem = this.commentItem;
            }
        } else {
            if (this.localItem !== this.parentItem){
                this.localItem = this.parentItem;
            }
        }
    },
    methods: {
        vote(item, delta){
            if (this.commentMode) {
                //If it is the vote control for a comment, then use the voteComment function
                this.voteComment(item, delta);
            } else {
                this.voteTreatment(item, delta)
            }
        },
        voteComment(comment, delta){
            console.log("Upvoting comment by: " + delta); // eslint-disable-line no-console

            //User has voted before?
            var hasVoted = false;
            var votePosition;
            //For each of the votes that have been cast
            for (var i = 0; i < comment.votedBy.length; i++){
                //
                var voter = comment.votedBy[i];

                //Is this the users vote?
                if (voter === this.$route.params.userDb.uid){
                    hasVoted = true;
                    votePosition = i;
                    break;
                }
            }

            //Create a copy of the object to avoid passing the original by value
            var baseComment =JSON.parse(JSON.stringify(comment));

            //We'll still need a correct treatment id passed in with the comment
            this.castVote(this.parentItem.id, baseComment.votedBy, baseComment.upvotes, hasVoted, delta, votePosition, true);

        },
        voteTreatment(treatment, delta){
            console.log("Upvoting/downvoting treatment by: " + delta); // eslint-disable-line no-console

            //User has voted before?
            var hasVoted = false;
            var votePosition;
            //For each of the votes that have been cast
            for (var i = 0; i < treatment.data.votedBy.length; i++){
                //
                var voter = treatment.data.votedBy[i];

                //Is this the users vote?
                if (voter === this.$route.params.userDb.uid){
                    hasVoted = true;
                    votePosition = i;
                    break;
                }
            }

            this.castVote(treatment.id, treatment.data.votedBy, treatment.data.upvotes, hasVoted, delta, votePosition, false);               
        },
        castVote(id, listOfVotes, numberOfVotes, hasVoted, delta, votePosition, commentMode){   
            if (hasVoted === true){
                //If the user has voted in the past, must remove their vote
                listOfVotes.splice(votePosition, 1);
                numberOfVotes = numberOfVotes - delta;
            } else {
                //Otherwise add as normally
                listOfVotes.push(this.$route.params.userDb.uid)
                numberOfVotes = numberOfVotes + delta;
            }

            var that = this;
            //Check whether we are casting the vote on a case or treatment comment
            //commentParent property    
            if (!commentMode){
                //Push the changes up to the firebase
                firebase.db
                .collection('treatments')
                .doc(id)
                .update({upvotes: numberOfVotes, votedBy: listOfVotes})
                .then(function(){
                    //If the treatment is part of a case, update the case
                    if (that.localItem.data.case.value && that.localItem.data.case.parentCases.length > 0) {
                        //For each parent case, update its upvotes
                        var updatePromises = [];
                        const treatmentDataService = new TreatmentDataService();

                        var updateObject;
                        if (hasVoted){
                            updateObject = {upvotes: fbAdmin.firestore.FieldValue.increment(-delta)};
                        } else {
                            updateObject = {upvotes: fbAdmin.firestore.FieldValue.increment(delta)};
                        }

                        //Execute all promises at once, use the treatmentDataServices update function
                        that.localItem.data.case.parentCases.forEach((caseId) => {                            
                            updatePromises.push(treatmentDataService.updateFirebaseById('cases', caseId, updateObject));
                        })

                        Promise.all(updatePromises)
                        .then(() => {
                            if (hasVoted === true) {
                                Toast.fire({  icon: 'success',  title: `Successfully removed upvote on treatment`});
                            } else {
                                Toast.fire({  icon: 'success',  title: `Successfully voted on treatment`});
                            }
                            //Push the activity to the tracker
                            that.activity = new Activity("Upvoted", {type: "Treatment", id: id}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
                            that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);

                            //Update this locally so it keeps track until we add a refresh? (Maybe a snapshot listener would eventually be worth it, but too many listeners can slow things down)
                            that.localItem.data.upvotes = numberOfVotes;
                            that.localItem.data.upvotedBy = listOfVotes;
                        }).catch((error) => {
                            Toast.fire({  icon: 'error',  title: `Error updating corresponding parent cases: ${error}`});
                        });                        
                    } else {
                        //Just show the normal toast messages
                        if (hasVoted === true) {
                            Toast.fire({  icon: 'success',  title: `Successfully removed upvote on treatment`});
                        } else {
                            Toast.fire({  icon: 'success',  title: `Successfully voted on treatment`});
                        }
                        //Push the activity to the tracker
                        that.activity = new Activity("Upvoted", {type: "Treatment", id: id}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
                        that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);
                    }                    
                })
                .catch(function(error){
                    Toast.fire({  icon: 'error',  title: `Error voting on treatment: ${error}`});
                });
            } else {
                //Push the activity to the tracker
                that.activity = new Activity("Upvoted", {type: "Comment", id: id}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
                that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);

                //Create the correct reference based on whether the parent type is a treatment or case
                var fbReference;
                if (this.parentType === "case"){
                    fbReference = firebase.db.collection('cases').doc(id);
                } else {
                    fbReference = firebase.db.collection('treatments').doc(id);
                }
                //Array union is limited in terms of changing specific items in the array. 
                //As a solution, I have to arrayRemove that specific object and then ArrayUnion back in the updated one

                //Will require the EXACT current comment to perform the initial remove        
                const currentComment = this.localItem;
                const newComment = {
                    commentText: currentComment.commentText, 
                    date: currentComment.date, 
                    owner: currentComment.owner, 
                    ownerName: currentComment.ownerName,
                    upvotes: numberOfVotes,
                    votedBy: listOfVotes
                }

                //First remove the current comment
                fbReference.update({comments: fbAdmin.firestore.FieldValue.arrayRemove(currentComment)})
                .then(() => {
                    //If this is successful, now update with the new object by performing the original intended arrayUnion
                    fbReference
                    .update({comments: fbAdmin.firestore.FieldValue.arrayUnion(newComment)}) //Need to update the comment here instead of the whole treatment
                    .then(function(){
                        Toast.fire({  icon: 'success',  title: `Successfully voted on comment`});

                        //Update this locally so it keeps track until we add a refresh? (Maybe a snapshot listener would eventually be worth it, but too many listeners can slow things down)
                        that.localItem.upvotes = numberOfVotes;
                        that.localItem.votedBy = listOfVotes;
                    })
                    .catch(function(error){
                        Toast.fire({  icon: 'error',  title: `Error voting on comment: ${error}`});
                    })
                })
                .catch(() => {
                    //If this fails, it is likely due to the comment changing since loading.
                    //Show an error, imploring them to try again! --> After we emit our 'refresh' --> (Not yet added)
                    Toast.fire({  icon: 'error',  title: `Error voting on comment, refresh the treatment and please try again!`});
                })                
            }
        },
        hasVoted(item){
            //User has voted before?
            var hasVoted = false;

            if (item.data && item.data.votedBy) {
                //For each of the votes that have been cast
                for (var i = 0; i < item.data.votedBy.length; i++){
                    //
                    var voter = item.data.votedBy[i];

                    //Is this the users vote?
                    if (voter === this.$route.params.userDb.uid){
                        hasVoted = true;
                        break;
                    }
                }
            }
            return hasVoted;
        },
        getVoteColour(item){
            //If comment mode, put in the treatment format
            var hasVoted = false;
            if (this.commentMode){
                hasVoted = this.hasVoted({id: "", data: item});
            } else {
                hasVoted = this.hasVoted(item);
            }
            
            if (hasVoted === true){
                return 'primary';
            } else {
                return 'grey lighten-1';
            }
        },
    }
  }
</script>